export const environment = { 
	production: true, 
	api: 'https://api-musee-carnac-collection.agence-11h10.fr', 
	url: 'https://collections.museedecarnac.com/'
};
